import EnergeticsIndex from './List'

export default [
  {
    path: '/energetics',
    name: 'energetics',
    component: EnergeticsIndex,
    meta: {
      auth: true,
      permission: 'view',
    },
  },
]
